import { Component, OnInit } from '@angular/core';
import { PoService } from '../po.service';

@Component({
  selector: 'app-recent-po',
  templateUrl: './recent-po.component.html',
  styleUrls: ['./recent-po.component.css']
})
export class RecentPoComponent implements OnInit {
  purchase_order : any = [];
  page=1;
  currentPage = 1;
  itemsPerPage = 5;
  pageSize: number;
  totalrecord:number;
  poFilter: any = { podate: '' };

  constructor(
    private poservice : PoService,
  ) { }

  ngOnInit() {
    this.getallRecentPurchaseOrder();
  }

  getallRecentPurchaseOrder() {
   
    return this.poservice.GetAllRecentPurchaseOrders()
               .subscribe(
                purchaseorder => {                
                  this.purchase_order = purchaseorder
                  this.totalrecord = this.purchase_order.length;
                 }
                );
 }

 
 public onPageChange(pageNum: number): void {
  this.pageSize = this.itemsPerPage*(pageNum - 1);
}

public changePagesize(num: number): void {
this.itemsPerPage = this.pageSize + num;
}


}
